import { render, staticRenderFns } from "./AnnotationWorkList.vue?vue&type=template&id=38dcbc84&"
import script from "./AnnotationWorkList.vue?vue&type=script&lang=js&"
export * from "./AnnotationWorkList.vue?vue&type=script&lang=js&"
import style0 from "./AnnotationWorkList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports